import e from 'react';
import { useRefCallback } from '@crossbell/util-hooks';
import { useAccountCharacter, useCharacterAttribute } from '@crossbell/react-account';

var f={otherApps:[]},C=e.createContext(null);function a(){let t=e.useContext(C);return e.useMemo(()=>({...f,...t}),[t])}function y(t){let{sentry:c}=a(),u=useAccountCharacter(),{data:g,update:o,isLoading:p}=useCharacterAttribute({characterId:u?.characterId,key:c?.dsn},t),r=!!g,s=useRefCallback(()=>o(!0)),i=useRefCallback(()=>o(null)),l=useRefCallback(()=>r?i():s());return {isEnabled:r,isLoading:p,toggle:l,disable:i,enable:s}}

export { C as a, a as b, y as c };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-JM7L7N4B.mjs.map